// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nRvex","right":"styles_right__xJA0U"};